<template>
    <div class="root">
      <div class="title">流量套餐</div>
      <div class="package-type">
        <div :class="type==0?'active':''" @click="changeType(0)">本月流量</div>
        <div :class="type==1?'active':''" @click="changeType(1)">次月流量</div>
      </div>
      <div class="balance" v-if="stockInfo.rechargeType==1">
        <span class="text-1">卡积分：</span><span class="text-2"> {{stockInfo.balance}}分</span>
        <span  class="text-3" @click="rechargeBalance">充值</span>
      </div>
      <div class="shownetType" v-if="showNetType && showNetType.length > 1">
        <div :class="{'active':activeNet==item}" v-for="(item,index) in showNetType" :key="index" @click="activeNet=item">{{netType[item]}}</div>
      </div>
      <div class="package-list">
        <template v-if="packageList.length>0">
        <div class="package-item" v-for="item in packageList" :key="item.id" v-if="item.netType==activeNet">
          <div class="top" :class="{'color1':item.month<12,'color2':item.month==12,'color3':item.month>12}">
            <div class="left">
              <div class="package-title">{{ item.title}}</div>
              <div class="yuebao">
                <img src="../assets/images/bao_03.png">
                <span>{{item.typeName}}</span>
              </div>
              <div class="expire">
                <img src="../assets/images/expire_03.png">
                <span>{{ item.startDate }}-{{ item.endDate }}</span>
              </div>
            </div>
            <div class="right">
              <div class="price">
                <span class="icon">&yen;</span>
                <span>{{item.price}}</span>
              </div>
              <div class="btn" @click="checkPackage(item),createOrder()">立即{{stockInfo.rechargeType==1?'兑换':'订购'}}</div>
            </div>
          </div>
          <div class="desc">
            {{item.desc}}
          </div>
        </div>
        </template>
        <div v-else class="empty">
          没有可充值的套餐
        </div>
      </div>
      <div class="tips">
        <div class="tp-title">温馨提示</div>
        <ul class="tp-content">
          <li>网络服务由当地优质运营商提供，安全靠谱</li>
          <li>购买后 30 天之内随时启用，有效期将从启用后开始计算，每 24 小时计为1天，一经启用，无法暂停计时</li>
          <li>购买后使用 30 天以内，可在公众号联系客服取消订单在海岛、隧道、山区、高速公路、沙漠等偏远地区，受限于运营商网络覆盖，可能会出现信号较弱和信号丢失的情况</li>
          <li>开启热点共享时，建议关闭接入手机的同步、备份等功.能，避免套餐流量消耗过快</li>
        </ul>
      </div>
    </div>
</template>

<script>
    export default {
        name: "recharge",
        data() {
            return {
                iccid:'',
                packageID:0,
                type:0,
                //packageList:[],
                packageGroup:[],
                one:{},
                stockInfo:{},
                tips:[],
                operator:{},
                authRecharge:0,
              showNetType:[],
              showNetTypeIndex:[],
              activeNet:0,
                netType: {
                  2: '单网套餐',
                  3: '单网套餐',
                  4: '单网套餐',
                  5: '双网套餐',
                  6: '双网套餐',
                  7: '双网套餐',
                  0: '三网套餐',
                },
            };
        },
        computed:{
            packageList(){
                if( this.packageGroup[this.type]) {
                    return this.packageGroup[this.type]
                }else{
                    return []
                }
            },

        },
        watch:{
            type:function () {
                if(!this.packageGroup[this.type]) {
                    this.queryPackageList(this.type);
                }
            }
        },
        methods: {
            queryPackageList(type){
                this.$toast.loading()
                this.showNetType = []
              this.showNetTypeIndex = [];
                this.fetchData('/package/getRechargePackage',{iccid:this.iccid,type:type},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                      for (let i in res.data){
                        if(!this.showNetTypeIndex[res.data[i].netType]){
                          this.showNetType.push(res.data[i].netType);
                          this.showNetTypeIndex[res.data[i].netType] = true
                        }
                      }
                        this.showNetType.sort((a,b)=>{
                          if(a == 0) return a-b;
                          if(b == 0 ) return b-a;
                          return b-a
                        })
                        this.activeNet = this.showNetType[0];
                        this.$set(this.packageGroup ,type,res.data)
                        this.$forceUpdate()
                    }else{
                        if(this.packageGroup[1-type]){
                          this.type = 1-type
                        }
                        this.packageGroup[type]=[]
                    }
                })
            },
            checkPackage(item){
                this.packageID = item.id
                this.one = item;
            },
            changeType(type){
                this.type = type;
            },
        createOrder(){
                if(this.authRecharge == 0){
                    this.$toast('请实名后再续费,若已实名，请尝试刷新网页重试');
                    return false;
                }
                if(this.type == 0 && this.one.alertMsg){
                  this.$dialog.confirm({
                    title: '提示',
                    message: this.one.alertMsg
                  }).then(() => {
                    if(this.stockInfo.rechargeType==1) {
                        this.commitorderbalance()
                      }else {
                          this.commitorder()
                      }
                  }).catch(() => {
                    // on cancel
                  });
                }else{
                  if(this.stockInfo.rechargeType==1) {
                        this.commitorderbalance()
                      }else {
                          this.commitorder()
                      }
                }
            },
          commitorder(){
            this.$toast.loading({ forbidClick: true })
            this.fetchDataPost('/order/createOrder',{iccid:this.iccid,packageID:this.packageID,type:this.type},(res)=>{
              this.$toast.clear();
              if(res.code){
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', res.data,
                  (res)=>{
                    if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                      this.$toast.success('支付成功');
                      this.$router.push({name:'index',query:{iccid:this.iccid}})
                    }
                  }
                );
              }else{


                if(res.url){
                  if(res.msg) {
                    this.$dialog.confirm({
                      title: "提示",
                      message: res.msg
                    }).then(() => {
                      // on confirm
                      let query = {}
                      if (res.data) {
                        query = res.data
                      }
                      query.cardno = this.iccid
                      sessionStorage.removeItem('token');
                      this.$router.push({path: res.url, query: query})
                    }).catch(() => {
                      // on cancel
                    })
                  }else{
                    this.$router.push({path: res.url, query: res.data})
                  }
                }else {
                  if (res.msg.indexOf('appid') !== -1 && res.msg.indexOf('openid') !== -1) {
                    this.$toast.fail('登录失效，请尝试重新进入查询')
                    sessionStorage.clear()
                  } else {
                    this.$dialog.alert({
                      title: '提示',
                      message: res.msg,
                    }).then(() => {

                    });

                  }
                }


              }
            })
          },
	  commitorderbalance(){
      this.$toast.loading({ forbidClick: true })
                this.fetchDataPost('/order/createOrderbalance',{iccid:this.iccid,packageID:this.packageID,type:this.type},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success(res.msg)
                        setTimeout(res=>{
                            this.$router.back()
                        },1500)
                    }else{
                        this.$toast(res.msg)
                        if(res.msg && res.msg.indexOf("积分") !== -1){
                            setTimeout(res=>{
                                this.rechargeBalance()
                            },1500)

                        }
                    }

                })
            },
            rechargeBalance(){
                this.$router.push({name:"cardBalance",query: {iccid:this.iccid}})
            },

            getStockInfo(){
                this.fetchData('/card/info',{iccid:this.iccid},(res)=>{
                    this.stockInfo = res.data
                    if(this.stockInfo.amount > 0){
                        this.type = 1
                    }
                })
            },
            getTips(){
                this.fetchData('/card/tips',{iccid:this.iccid},(res)=>{
                    console.log(res.data)
                    this.tips = res.data.split("\n")
                })
            },
            getCardOperator(){
                this.fetchData('/card/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                        if(this.operator.activeRule == 1){
                            this.fetchData('/card/status', {iccid: this.iccid}, (res) => {
                              console.log(res.data)
                                if (!res.data.simAuthStatus) {
                                    this.$dialog.alert({
                                        title: '实名提示',
                                        message: '请先完成实名',
                                    }).then(() => {
                                        // on close
                                        window.location.href = this.operator.authUrl
                                    });
                                }else{
                                    this.authRecharge = 1
                                }
                            })
                        }else{
                            this.authRecharge = 1
                        }
                    }
                })
            }
        },
        created: function () {
            let query = this.$route.query;
            this.iccid = query.iccid;
            this.getStockInfo()
            this.getCardOperator();
            this.queryPackageList(this.type)
            this.getTips()
        }
    };
</script>
<style lang="scss" scoped>
.root{
  .tips{
    width: 6.2rem;
    margin: .4rem auto;
    color: #fff;
    .tp-title{
      font-size: .32rem;
    }
    .tp-content{
      margin-top: .26rem;
      margin-left: .32rem;
      li{
        line-height: .34rem;
        font-size: .26rem;
        margin-top: .1rem;
        list-style: square;
      }
    }
  }
  .shownetType{
    width: 6.5rem;
    display: flex;
    font-size: .3rem;
    margin: .4rem auto 0;
    padding: .2rem .4rem;
    background: #fff;
    div{
      flex: 1;
      line-height: 1;
      display: inline-block;
      text-align: center;
      border-right: 2px solid #333;
    }
    div.active{
      color: #f2616b;
    }
    :last-child{
      border-right: none;
    }
  }
  .balance{
    width: 3.64rem;
    background: #fff;
    text-align: center;
    padding: .12rem 0;
    margin: .3rem auto 0;
    .text-1{
      font-size: .30rem;
    }
    .text-2{
      font-size: .3rem;
      color: #3690e3;
    }
    .text-3{
      display: inline-block;
      background: #f2616b;
      border-radius: .08rem;
      color: #fff;
      padding: .06rem .14rem;
      margin-left: .16rem;
      line-height: 1;
      font-size: .3rem;
    }
  }
  height: inherit;
  font-size: 0;
  background: linear-gradient(180deg, #f05864,#f2616b);
  overflow-y: scroll;
  .package-list{
    .empty{
      font-size: .36rem;
      color: #fff;
    }
    width: 6.35rem;
    margin:.3rem auto;
    .package-item{
      width: 5.55rem;
      padding: .2rem .4rem;
      background: #fff;
      border-radius: .3rem;
      margin-bottom: .34rem;
      .top{
        display: flex;
        .left{
          width: 4.35rem;
          .package-title{
            font-size: .32rem;
            color: #000;
            text-align: left;
          }
          .expire{
            margin-top: .04rem;
            span{
              font-size: .24rem;
              color: #333;
              vertical-align: middle;
              display: inline-block;
              margin-left: .06rem;
            }
            img{
              width: .2rem;
              vertical-align: middle;
            }
          }
          .yuebao{
            img{
              width: .2rem;
              height: .2rem;
              vertical-align: middle;
            }
            span{
              display: inline-block;
              color: #fff;
              font-size: .2rem;
              vertical-align: middle;
              margin-left: .06rem;
              line-height: 1;
              margin-top: -.03rem;
            }
            display: inline-block;
            padding: .06rem .09rem;
            background: #afd5fc;
            border-radius: .1rem;
            margin: .16rem 0;
          }
        }
        .right{
          width: 2rem;
          .price{
            img{
              width: .25rem;
              height: .25rem;
              display: inline-block;
              margin-right: .08rem;
              margin-left: .04rem;
              vertical-align: middle;
            }
            span{
              color: #f05864;
              font-size: .36rem;
              vertical-align: middle;
            }
            .icon{
              font-size: .2rem;
              border-width: 1px;
              border-style: solid;
              border-radius: 100%;
              display: inline-block;
              width: .2rem;
              height: .2rem;
              text-align: center;
              line-height: .2rem;
              vertical-align: middle;
              margin-right: .06rem;
            }
            margin-bottom: .2rem;
          }
          .btn{
            display: inline-block;
            color: #fff;
            font-size: .28rem;
            background: #f05864;
            width: 1.46rem;
            text-align: center;
            height: .4rem;
            line-height: .4rem;
          }
        }
      }
      .top.color1{
        .left{
          .package-title{
            color: #4EA6FFFF;
          }
        }
        .right{
          .price{
            span{
              color: #4EA6FFFF;
            }
            .icon{
              border-color: #4EA6FFFF;
            }
          }
          .btn{
            background: #4EA6FFFF;;
          }
        }
      }
      .top.color2{
        .left{
          .package-title{
            color: #F25764FF;
          }
        }
        .right{
          .price{
            span{
              color: #F25764FF;
            }
            .icon{
              border-color: #F25764FF;
            }
          }
          .btn{
            background: #F25764FF;;
          }
        }
      }
      .top.color3{
        .left{
          .package-title{
            color: #FF8A44FF;
          }
        }
        .right{
          .price{
            span{
              color: #FF8A44FF;
            }
            .icon{
              border-color: #FF8A44FF;
            }
          }
          .btn{
            background: #FF8A44FF;;
          }

        }
      }
      .desc{
        margin-top: .2rem;
        font-size: .28rem;
        color: #333;
      }
    }
  }
  .title{
    font-size: .36rem;
    text-align: center;
    color: #fff;
    padding: .2rem 0 ;
   letter-spacing: .1rem;
  }
  .package-type{
    height: .7rem;
    display: flex;
    background: #fff;
    div{
      flex: 1;
      text-align: center;
      line-height: 1;
      color: #000;
      font-size: .32rem;
      display: inline-block;
      height: .32rem;
      margin-top: .19rem;
    }
    div.active{
      color: #f05864;
    }
    :first-child{
      border-right: 3px solid #000;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/recharge.vue